import { TableCell } from '@material-ui/core';
import styled from 'styled-components';

export const LeftBorderTableCell = styled(TableCell)`
    border-left: 1px solid rgba(224, 224, 224, 1);
`;

export const NoWrapTableCell = styled(LeftBorderTableCell)`
    white-space: nowrap;
`;
